import React, { useEffect, useState } from "react";
import { Container, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import NoDataFound from "../../../components/common/NoDataFound";
import TopBarCard from "./TopBarCard";
import ReviewSummary from "./ReviewSummary";
import TopicsCustomers from "./TopicsCustomers";
import PositiveNegativeRatings from "./PositiveNegativeRatings";
import ReviewHistory from "./ReviewHistory";
import { useDispatch, useSelector } from "react-redux";
import { getRatingDashboardDetails } from "store/actions/dashboardSlice";
import { getMinMaxDate } from "components/common/Utils";
import CompletedAndCancellationBookings from "./CompletedAndCancellationBookings";
import ReviewDashboardShimmer from "components/ShimmerEffects/ReviewDashboardShimmer";

const Reviews = () => {
  const { t } = useTranslation();
  document.title = t("Reviews Dashboard | Ashjar Space");

  const dispatch = useDispatch();

  const { loading, ratingDashboardDetails } = useSelector(
    (state) => state.Dashboards
  );

  // console.log(ratingDashboardDetails);

  const [dates, setDates] = useState([]);
  const [branches, setBranches] = useState([]);
  const [spaceTypes, setSpaceTypes] = useState([]);

  useEffect(() => {
    getAllData();
  }, []);

  const getAllData = (action) => {
    const { actionType } = action || {}; // SEARCH, RESET, RESET_KEYWORD

    const isReset = actionType === "RESET";
    const payload = {
      spaceTypeInt: isReset ? [] : spaceTypes, // [] for all , 1 - workspace, 2- meetingroom, 3 - workshop
      branches: isReset ? [] : branches,
      dateRange: isReset ? {} : getMinMaxDate(dates),
    };
    dispatch(getRatingDashboardDetails(payload));
  };

  const handleReset = () => {
    setDates([]);
    setBranches([]);
    setSpaceTypes([]);
    getAllData({ actionType: "RESET" });
  };

  return (
    <React.Fragment>
      <div className="page-content reviews_dashboard">
        {loading ? (
          <ReviewDashboardShimmer />
        ) : (
          <Container fluid>
            <Row>
              <h1 className="main_title">{t("Reviews")}</h1>
            </Row>

            {/* TOP ROW */}
            <Row className="top_row">
              {ratingDashboardDetails?.averageByType?.length > 0 ? (
                ratingDashboardDetails?.averageByType?.map((item) => (
                  <TopBarCard key={item?._id} item={item} />
                ))
              ) : (
                <NoDataFound text={t("No reviews found")} />
              )}
            </Row>

            <div className="inner_wrapper">
              {/* Reviews Summery Row */}
              <Row className="common_row mt-0">
                <ReviewSummary
                  ratingDashboardDetails={ratingDashboardDetails}
                  dates={dates}
                  setDates={setDates}
                  branches={branches}
                  setBranches={setBranches}
                  spaceTypes={spaceTypes}
                  setSpaceTypes={setSpaceTypes}
                  getAllData={getAllData}
                  handleReset={handleReset}
                />
              </Row>

              <Row>
                <div className="d-flex gap-3 w-100 p-0">
                  <TopicsCustomers
                    topTerms={ratingDashboardDetails?.topTerms}
                  />
                  <PositiveNegativeRatings
                    ratingDashboardDetails={ratingDashboardDetails}
                  />
                </div>
              </Row>

              <Row className="common_row booking_row">
                <CompletedAndCancellationBookings />
              </Row>

              <Row className="common_row">
                <ReviewHistory
                  ratingDashboardDetails={ratingDashboardDetails}
                />
              </Row>
            </div>
          </Container>
        )}
      </div>
    </React.Fragment>
  );
};

export default Reviews;
